<template lang="pug">
  div
    v-btn(
      block
      color="primary"
      @click="toggleFilterDialog()"
      ) Settings
    v-dialog(
      v-model="dialog"
      max-width="500px"
      )
      v-card
        v-card-title Settings
        v-card-text
          //- v-select(
          //-   label="Weekdays to show"
          //-   :items="availableWeekdays"
          //-   v-model="weekdays"
          //-   multiple
          //-   chips
          //-   hint="Narrow down results by selecting specific weekdays"
          //-   persistent-hint
          //-   disabled
          //- )
          v-form
            map-review-budget
            DateTime(
              type="Start"
              identity="start"
              v-on:dateChange="updateDate"
              v-on:timeChange="updateTime"
              :initialDate="filterDate.start"
              :initialTime="filterTime.start"
            )
            DateTime(
              type="Stop"
              identity="stop"
              v-on:dateChange="updateDate"
              v-on:timeChange="updateTime"
              :initialDate="filterDate.stop"
              :initialTime="filterTime.stop"
            )
        v-card-actions
          v-btn(
            color="primary"
            flat
            @click.stop="dialog = false"
          ) Close
</template>

<script>
import { mapGetters } from 'vuex'
import DateTime from '@/components/datetime/DateTime'
import MapReviewBudget from "@/components/map/MapReviewBudget";

export default {
  name: 'MapMenuFilterDialog',
  components: {DateTime, MapReviewBudget},
  data () {
    return {
      availableWeekdays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
    }
  },
  computed: {
    ...mapGetters([
      'filterDate',
      'filterTime',
    ]),
    dialog: {
      get () {
        return this.$store.state.filterDialog
      },
      set () {
        this.$store.dispatch('TOGGLE_FILTER_DIALOG')
      }
    },
    weekdays: {
      get () {
        return this.$store.state.weekdays
      },
      set (value) {
        this.$store.dispatch('SET_WEEKDAYS', value)
      }
    },
  },
  methods: {
    updateDate: function (val) {
      const identity = (val.type === 'Start') ? 'start' : 'stop'
      this.$store.dispatch('UPDATE_DATE', {
        type: val.type,
        identity: identity,
        date: val.date
      })
    },
    updateTime: function (val) {
      const identity = (val.type === 'Start') ? 'start' : 'stop'
      this.$store.dispatch('UPDATE_TIME', {
        type: val.type,
        identity: identity,
        time: val.time
      })
    },
    toggleFilterDialog: function() {
      this.$store.dispatch("TOGGLE_FILTER_DIALOG");
    }
  }
}</script>
